import { convertToTitleCase } from "../../../utils/helpers";
import { KYC_MATCH_RESULT } from "../../../store/admin/investorOperations/constants";

const MATCH_CONFIG = {
  [KYC_MATCH_RESULT.FULL_MATCH]: { label: "Full match", color: "#19BC31", bg: "rgba(25, 188, 49, 0.1)" },
  [KYC_MATCH_RESULT.PARTIAL_MATCH]: { label: "Partial match", color: "#ff9500", bg: "rgba(255, 149, 0, 0.1)" },
  [KYC_MATCH_RESULT.MISMATCH]: { label: "Mismatch", color: "#FF4343", bg: "rgba(255, 67, 67, 0.1)" },
  [KYC_MATCH_RESULT.PROVIDER_UNAVAILABLE]: { label: "Provider unavailable", color: "#525252", bg: "#f1f1f1" },
};

export default function KycMatchIndicator({ matchResult, showLabel = true }) {
  const cfg = MATCH_CONFIG[matchResult] || {
    label: convertToTitleCase(String(matchResult || "unknown").replace(/_/g, " ")),
    color: "#525252",
    bg: "#f1f1f1",
  };

  return (
    <span
      className="d-inline-block rounded-pill px-2 py-1 small fw-semibold"
      style={{ backgroundColor: cfg.bg, color: cfg.color }}
    >
      {showLabel ? cfg.label : "●"}
    </span>
  );
}

export function FieldMatchIndicator({ matched, label }) {
  return (
    <span className="d-flex align-items-center gap-2 small">
      <span
        className="rounded-circle d-inline-block"
        style={{
          width: 8,
          height: 8,
          backgroundColor: matched ? "#19BC31" : "#FF4343",
        }}
      />
      <span>{label}</span>
      <span className="text-muted">{matched ? "Match" : "Mismatch"}</span>
    </span>
  );
}
